import { render, staticRenderFns } from "./AlacakliCardInfo.vue?vue&type=template&id=31baa2c2"
import script from "./AlacakliCardInfo.vue?vue&type=script&lang=ts"
export * from "./AlacakliCardInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports